import { useEffect, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ExpenseNoteForm from "@components/forms/ExpensesNoteForm";
import { ExpenseApi, ExpenseDataType } from "@/api/ExpenseApi";
import { ExpenseFormDataKeys } from "@/generated/ExpenseFormDataKeys";
import { ExpenseRelatedAttributes } from "@/formTypes/ExpenseDataType";

const ExpenseNoteAddEdit = () => {
  const params = useParams()
  const { id: expenseNoteId, expenseId } = params;
  const [expense, setExpense] = useState<ExpenseDataType>({})

  useEffect(() => {
    if (expenseId) {
      const run = async (expenseId: string) => {
        const invoices = await ExpenseApi.get(expenseId, {
          selectionSet: [
            ...ExpenseFormDataKeys.filter(k => !ExpenseRelatedAttributes.includes(k)),
            "currency.*",
            "expenseNotes.*"
          ]
        });
        setExpense(invoices);
      }
      run(expenseId);
    }
  }, [expenseId]);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!expenseNoteId ? 'Agregar' : 'Editar'} Nota de Credito Gasto`}
      backUrl={`/user/expenses/notes/${expenseId}`}
      primaryActions={
        [
          {
            actionTitle: "Guardar",
            formId: "expenseNoteForm",
            type: "submit",
            color: "success"
          }
        ]}
    >
      {expense?.id && (
        <ExpenseNoteForm
          formId="expenseNoteForm"
          id={expenseNoteId}
          expense={expense}
          saveRedirectUrl={`/user/expenses/notes/${expenseId}`}
        ></ExpenseNoteForm>
      )}

    </PageContainer >
  );
}

export default ExpenseNoteAddEdit;
